const quotaColumns = [
  {
    title: 'Базовый',
    dataIndex: 'basic',
    key: 'basic',
    width: '25%',
  },
  {
    title: 'Старт', 
    dataIndex: 'start',
    key: 'start',
    width: '25%',
  },
  {
    title: 'Продвинутый',
    dataIndex: 'advanced',
    key: 'advanced',
    width: '25%',
  },
  {
    title: 'Корпоративный',
    dataIndex: 'enterprise',
    key: 'enterprise',
    width: '25%',
  },
];

export default quotaColumns;